import { FrequencyType } from '@cognitivecredit/ui-utils'

export interface ForecastListItem {
  title: string | null
  reportingFreq: FrequencyType | null
  createdBy: string | null
  updatedAt: string | null
  createdAt: string | null
  shared: boolean | null
  yearEnd: string | null
  emailAddress: string | null
  reportingCurrency: string | null
  periodType: string | null
  forecastId: string | null
}

export interface ForecastListMetadataCount {
  count: number
  totalCount: number
}

export interface ForecastListResponse {
  error: string | null
  data: ForecastListItem[]
  metadata: {
    all: ForecastListMetadataCount
    mine: ForecastListMetadataCount
    team: ForecastListMetadataCount
  }
}

export interface FinancialModelSummary {
  financialId: string
  title: string | null
  shared: boolean | null
  latestVersion: string | number | null
}

export interface ModelLinks {
  upload?: { grid: string | null; map: string | null } | null
  download?: { grid: string | null; map: string | null } | null
}

export interface LoadedModel {
  id?: string
  forecastId?: string
  financialId?: string
  title?: string | null
  data?: string | null
  type?: string | null
  shared?: boolean | null
  createdBy?: string | null
  createdAt?: string | null
  updatedAt?: string | null
  emailAddress?: string | null
  reportingFreq?: FrequencyType | null
  yearEnd?: string | null
  reportingCurrency?: string | null
  periodType?: string | null
  gridLink?: string | null
  mapLink?: string | null
  gridStorageId?: string | null
  mapStorageId?: string | null
  pipelineBatchId?: string | null
  sbodBatchId?: string | null
  batchId?: string | null
  batchType?: string | null
  companyId?: string | null
  userId?: string | null
  versionId?: string | null
  version?: string | number | null
  latestVersion?: string | number | null
  versionCreatedAt?: string | null
  financialCreatedAt?: string | null
  financialUpdatedAt?: string | null
  links?: ModelLinks | null
  alreadySaved?: boolean
}

export interface ModelUpdateAvailability {
  status?: string | null
  message?: string | null
  periods?: string[] | null
  error?: string | null
}

export interface ModelState {
  forecastList: ForecastListResponse | [] | Record<string, never>
  financialsList: FinancialModelSummary[]
  availableSaving: boolean
  alreadySaved: boolean
  isSaving: boolean
  isUpdating: boolean
  loadedModel: LoadedModel | undefined
  modelType: 'forecast' | 'financials' | undefined
  hasUpdates: false | ModelUpdateAvailability
  isPreviewMode: boolean
}

export const getDefaultState = (): ModelState => ({
  forecastList: [],
  financialsList: [],
  availableSaving: false,
  alreadySaved: false,
  isSaving: false,
  isUpdating: false,
  loadedModel: undefined,
  modelType: undefined,
  hasUpdates: false,
  isPreviewMode: false,
})

export default getDefaultState()
